import { Address, OrderDelivery, OrderStatus } from '@open-tender/types'
import { ExternalLink } from 'components/icons'
import { DeliveryLink } from 'components'

const OrderAddress = ({
  address,
  delivery,
  status,
  isCard,
  children,
}: {
  address: Address
  delivery?: OrderDelivery | null
  status?: OrderStatus
  isCard?: boolean
  children?: React.ReactNode
}) => {
  const { street, unit, city, state, postal_code, company, contact, phone } =
    address || {}
  const streetAddress = street ? `${street}${unit ? `, ${unit}` : ''}` : null
  const contactPhone =
    contact || phone ? [contact, phone].filter((i) => i).join(' @ ') : null
  const trackingUrl = status === 'OPEN' && delivery && delivery.tracking_url
  return (
    <>
      {company ? (
        <>
          <p className={isCard ? 'title' : ''}>{company}</p>
          <p>{streetAddress}</p>
        </>
      ) : streetAddress ? (
        <p className={isCard ? 'title' : ''}>{streetAddress}</p>
      ) : (
        <p className={isCard ? 'title' : ''}>{postal_code}</p>
      )}
      <p>
        {city}, {state} {postal_code}
      </p>
      {contactPhone && <p>{contactPhone}</p>}
      {trackingUrl && (
        <p>
          <DeliveryLink
            text="Check delivery status"
            trackingUrl={trackingUrl}
            newWindowIcon={<ExternalLink />}
          />
        </p>
      )}
      {children}
    </>
  )
}

export default OrderAddress
